import { ITermCourse, ISectionType, IPlannedCourse, ICourse } from '../../../interfaces/scheduler_interfaces';
import { key } from 'core-ts-types';
import { Datasource, IDatasource, Metasource } from 'utility-ng-kernel';
import { TermCourse } from '../builders/term_course_builder';
import { ITermSectionTypesDatasource } from './term_section_types_datasource';
import * as _4 from 'lodash4';
import { ITermPlannedCoursesDatasource } from './term_planned_courses_datasource';
import { SectionTypeFilters } from '../filters/section_type_filters';

export interface ITermCoursesDatasource extends IDatasource<ITermCourse> {}

class CoursesMeta {
  _section_types: ISectionType[];
  _section_parts: ISectionType[];
  _has_multi_section_types: boolean;
  _planned_course: IPlannedCourse;
  _session_section_types: any[];
  _missing_prereqs: ICourse[];
  _missing_coreqs: ICourse[];
  _coreq_courses: ICourse[];
  id: key;
}

angular.module('capability-ng-scheduler').factory(
  'ngTermCoursesDatasource',
  (
    ngTermSectionTypesDatasource: ITermSectionTypesDatasource,
    ngTermPlannedCoursesDatasource: ITermPlannedCoursesDatasource,
    ngSectionTypeFilters: SectionTypeFilters
  ): ITermCoursesDatasource =>
    new Datasource<ITermCourse, CoursesMeta>({
      builderType: TermCourse,
      writeMode: 'clobber',
      updateMode: 'merge'
    }).includeMetasource<CoursesMeta>((datasource) =>
      new Metasource<ITermCourse, CoursesMeta>(datasource)
        .includeAttribute('_section_types', (course: ITermCourse) => {
          return _4.filter(ngTermSectionTypesDatasource.read(), (sectionType) => sectionType.course === course.id);
        })
        .includeAttribute('_section_parts', (course: ITermCourse) => {
          return _4.uniqBy(
            _4.filter(ngTermSectionTypesDatasource.read(), (sectionType) => sectionType.course === course.id),
            'name'
          );
        })
        .includeAttribute('_has_multi_section_types', (course: ITermCourse) => {
          return (
            _4.size(_4.filter(ngTermSectionTypesDatasource.read(), (sectionType) => sectionType.course === course.id)) >
            1
          );
        })
        .includeAttribute('_planned_course', (course: ITermCourse) => {
          return _4.find(ngTermPlannedCoursesDatasource.read(), (plannedCourse) => plannedCourse.course === course.id);
        })
        .includeAttribute('_session_section_types', (course: ITermCourse) => {
          const sectionTypes = _4.filter(
            ngTermSectionTypesDatasource.read(),
            (sectionType) => sectionType.course === course.id
          );
          return ngSectionTypeFilters.getSessionSectionTypesForCourse(sectionTypes);
        })
        .includeAttribute('_missing_prereqs', (course: ITermCourse) => {
          const courses = datasource.read();
          const plndCourse = _4.find(
            ngTermPlannedCoursesDatasource.read(),
            (plannedCourse) => plannedCourse.course === course.id
          );
          const preReqIds: number[] = _4.concat(
            _4.get(plndCourse, 'prereq_miss', []),
            _4.get(plndCourse, 'prereq_outoforder', [])
          );
          const preRequisites = _4.compact(_4.map(preReqIds, (preReqId) => _4.find(courses, (c) => c.id === preReqId)));

          return preRequisites;
        })
        .includeAttribute('_missing_coreqs', (course: ITermCourse) => {
          const plndCourse = _4.find(
            ngTermPlannedCoursesDatasource.read(),
            (plannedCourse) => plannedCourse.course === course.id
          );
          const courses = datasource.read();
          const coReqIds: number[] = _4.concat(
            _4.get(plndCourse, 'coreq_miss', []),
            _4.get(plndCourse, 'coreq_outoforder', [])
          );
          const coRequisites = _4.compact(_4.map(coReqIds, (coReqId) => _4.find(courses, (c) => c.id === coReqId)));
          return coRequisites;
        })
        .includeManyToMany('_coreq_courses', datasource, 'coreq')
    )
);



// WEBPACK FOOTER //
// ./app/vendor/capability-ng-scheduler/src/views/term_courses/datasources/term_courses_datasource.ts